<template>
  <v-tooltip content-class="portal-tooltip" bottom v-if="isSanimpresa">
    <template v-slot:activator="{ on }">
      <span v-on="on" class="mr-1" :style="iconContainerStyle"
        ><img :src="iconSA" alt="" :style="iconStyle"
      /></span>
    </template>
    <span v-if="tooltipText">{{ $t(tooltipText) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    isSanimpresa: {
      type: Boolean,
      required: true,
      default: false
    },
    tooltipText: {
      type: String,
      required: false,
      default: null
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: "bottom"
    },
    iconColor: {
      type: String,
      required: false,
      default: "p"
    },
    iconDimension: {
      type: String,
      required: false,
      default: "30px"
    },
    marginTop: {
      type: String,
      required: false,
      default: "0px"
    }
  },
  data: function () {
    return {
      iconSA: require(`@/restricted-library/assets/images/${this.iconColor}_sa_logo.png`)
    };
  },
  computed: {
    iconContainerStyle() {
      return `height: ${this.iconDimension} !important; margin-top: ${this.marginTop} !important`;
    },
    iconStyle() {
      return `width: ${this.iconDimension} !important; height: ${this.iconDimension} !important`;
    }
  }
};
</script>
